import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';
import { PermissionService } from '../service/permission/permission.service';

export const permissionGuard = (
    project: string,
    module: string,
    action: string
): CanActivateFn => {
    return () => {
        const permService = inject(PermissionService);
        const authService = inject(AuthService);
        const router = inject(Router);

        if (permService.can(project, module, action)) {
            return true;
        }

        // A route valid a moment ago can stop being valid after a role change (edited in
        // sportiq-main, then F5'd here) — that's not a security incident, just a stale link.
        // Land on wherever this account's CURRENT permissions actually work instead of
        // /unauthorized, which force-logs-out after 10s — reserve that page for the case where
        // there's genuinely nothing this account can access at all (getClubLandingRoute()'s own
        // fallback).
        if (authService.isClub()) {
            router.navigate([permService.getClubLandingRoute()]);
        } else if (authService.isFederation()) {
            router.navigate(['/federation']);
        } else {
            router.navigate(['/unauthorized']);
        }
        return false;
    };
};

/**
 * Guard that checks if user has ANY permission in a project.
 * Use on project-level routes.
 */
export const projectAccessGuard = (project: string): CanActivateFn => {
    return () => {
        const permService = inject(PermissionService);
        const router = inject(Router);

        if (permService.hasAnyPermission(project)) {
            return true;
        }

        router.navigate(['/no-access']);
        return false;
    };
};
